import React, { useMemo, useContext } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import useFormattingMap from '@ubeya/shared-web/hooks/useFormattingMap';
import { ExtraSmall } from '@ubeya/shared-web/components';

const ScheduleValue = styled(ExtraSmall)`
  color: ${({ theme }) => theme.colors.grey3};
`;

const ScheduleValueSummary = styled.div`
  font-weight: 500;
`;

const ShiftHoursRenderer = ({ rowData: { summarized, scheduleTotal, scheduleIn, scheduleOut } }) => {
  const { t, timeFormat } = useContext(ConfigContext);
  const formattingMap = useFormattingMap();

  const scheduleDuration = useMemo(
    () => scheduleIn && scheduleOut && formattingMap.number(scheduleTotal / 1000 / 60 / 60),
    [formattingMap, scheduleIn, scheduleOut, scheduleTotal]
  );

  const shiftTime = `${moment(scheduleIn).format(timeFormat)}
     ${scheduleOut && moment(scheduleOut).isValid() ? ` - ${moment(scheduleOut).format(timeFormat)}` : ''}`;

  if (summarized) {
    return (
      <ScheduleValueSummary style={{ unicodeBidi: 'plaintext' }}>
        {scheduleTotal ? ` ${formattingMap.number(scheduleTotal / 1000 / 60 / 60)}${t('h')}` : ''}
      </ScheduleValueSummary>
    );
  }

  if (!scheduleIn) {
    return null;
  }

  return (
    <div style={{ unicodeBidi: 'plaintext' }}>
      {shiftTime}
      <ScheduleValue>{scheduleDuration ? ` (${scheduleDuration}h)` : ''}</ScheduleValue>
    </div>
  );
};

export default ShiftHoursRenderer;
